<template>
    <div>
      <el-table :data="productItem.productItemsList" border style="width: 100%">
        <el-table-column
          label="序号"
          align="center"
          type="index"
          width="80">
        </el-table-column>
        <el-table-column
          prop="typeName"
          label="产品类别"
          width="120">
          <template slot-scope="scope">
            {{scope.row.typeName}}
          </template>
        </el-table-column>
        <el-table-column
          prop="itemName"
          label="产品/方法"
          width="140">
          <template slot-scope="scope">
            {{scope.row.itemName}}<span v-if="scope.row.refineFullName" style="color: red">[{{scope.row.refineFullName}}]</span>
<!--            <el-tag v-if="scope.row.itemIsGb === '1'" size="mini" type="success" style="margin-left: 5px;">国标</el-tag>-->
<!--            <el-tag v-if="scope.row.itemIsGb === '0'" size="mini" type="success" style="margin-left: 5px;">企标</el-tag>-->
          </template>
        </el-table-column>
        <el-table-column
          prop="mapList"
          label="检验项目">
           <template slot-scope="scope">
             <div v-for="(standard,index) in scope.row.standardList" :key="standard.itemId">
               <el-divider v-if="index>0"></el-divider>
               <i class="el-icon-caret-right" style="margin-right: 5px;color: #32A08C"></i>
               {{standard.itemName}}
               <el-tag v-if="standard.itemIsGb === '1'" size="mini" type="success" style="margin-left: 5px;">国标</el-tag>
               <el-tag v-if="standard.itemIsGb === '0'" size="mini" type="success" style="margin-left: 5px;">企标</el-tag>
               <div>
                <span v-for="(item,sindex) in standard.standardList" :key="item.itemId">
                  <span>
                  <el-divider v-if="sindex > 0" direction="vertical"></el-divider>
                  {{item.itemName}}（{{item.itemPrice}}元）
                  </span>
                </span>
               </div>
             </div>
           </template>
        </el-table-column>
        <el-table-column
          prop="totalPrice"
          width="160"
           label="价格">
        </el-table-column>
      </el-table>
      <div style="text-align: right;width: 100%;margin-top: 20px;">
        <div class="payment-calculate">
          <div>{{totalItem}}个检验项目，检验费用：<span class="money-text">{{productItem.price}}</span>元</div>
          <div>{{cycle.name}}（{{cycle.descript}}）：<span class="money-text">{{(cycle.price * productItem.price * 0.01)}}</span>元</div>
          <div>
            {{reports.name}}（{{formName}}）
            ：
            <span class="money-text">{{reports.price}}</span>元
          </div>
          <div>邮费：<span class="money-text">{{send.price}}</span>元</div>
          <el-divider></el-divider>

          <p class="mt-0" v-if="vipInfo">
            <span style="color: red">(会员)</span>
            应支付费用：<span style="color: red">{{productItem.vipPrice}}元</span>
            <del style="margin-left: 30px;font-size: 12px">原价：{{productItem.disPrice}}元</del>
          </p>
          <p class="mt-0" v-if="!vipInfo">
            应支付费用：<span  style="color: red">{{productItem.disPrice}}</span>元
            <span style="margin-left: 30px;font-size: 12px">会员价：</span>
            <span style="font-size: 12px;color: red">{{productItem.vipPrice}}</span>
            <span style="font-size: 12px">元</span>
          </p>
         <!-- <div style="font-weight: bold;">总费用：<span class="money-text" style="text-decoration:line-through;">{{productItem.disPrice}}</span>元</div>
          <div style="font-weight: bold;color: red;">会员专享价
            ：<span class="money-text">{{productItem.vipPrice}}</span>元</div>
          <div>
          </div>-->
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'price-detail',
  props: {
    productItem: {
      type: Object,
      default: function () {
        return {}
      }
    },
    entrust: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      testEntrust: {},
      reports: {
        name: '',
        price: 0
      },
      formName: '',
      cycle: {},
      totalItem: 0,
      send: {}
    }
  },
  created () {
    this.totalItem = 0
    this.productItem.productItemsList.forEach(product => {
      let totalPrice = 0
      product.standardList.forEach(stand => {
        this.totalItem = this.totalItem + stand.standardList.length
        stand.standardList.forEach(item => {
          totalPrice += Number(item.itemPrice)
        })
      })
      product.totalPrice = totalPrice
    })
    // 计算金额
    let that = this
    let newPirce = 0
    // 报告及发票
    this.productItem.sendTypeList.forEach(send => {
      if (that.entrust.reportSendCode === send.code) {
        this.send = send
        newPirce += isNaN(send.price) ? 0 : send.price
      }
    })
    // 报告类型
    this.productItem.reportTypeList.forEach(report => {
      if (that.entrust.reportTypeCodeArray.indexOf(report.code) > -1) {
        this.reports.name += ',' + report.name
        this.reports.price += report.price
        newPirce += isNaN(report.price) ? 0 : report.price
      }
    })
    if (this.reports.name) {
      this.reports.name = this.reports.name.substring(1)
    }
    let reportForm = this.commonUtils.getDictPara('report_form')
    reportForm.forEach(form => {
      if (that.entrust.reportFormCodeArray.indexOf(form.code) > -1) {
        this.formName += ',' + form.name
      }
    })
    if (this.formName) {
      this.formName = this.formName.substring(1)
    }
    // 检验周期
    let priceSite = 0
    let priceVipSite = 0
    this.productItem.cycleList.forEach(cycle => {
      if (that.entrust.cycleCode === cycle.code) {
        this.cycle = cycle
        priceSite = (isNaN(cycle.price) ? 0 : cycle.price) * 0.01 // 加成倍率
        priceVipSite = (isNaN(cycle.vipPrice) ? 0 : cycle.vipPrice) * 0.01 // 加成倍率
      }
    })
    let pirce = newPirce + (priceSite + 1) * this.productItem.price
    let vipPirce = newPirce + (priceVipSite + 1) * this.productItem.price
    this.productItem.disPrice = pirce.toFixed(2)
    this.productItem.vipPrice = vipPirce.toFixed(2)
  },
  computed: {
    vipInfo () {
      return this.$store.state.user.vipInfo
    }
  },
  methods: {
    toPopVip () {
      this.vip({
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .money-text{
    display: inline-block;
    width: 70px;
  }
  .payment-calculate{
    width: 50%;
    margin-left: auto;
    text-align: right;
  div{
    margin: 5px 0;
  }
  }
</style>
